'use client';

import React, { useEffect, useState } from 'react';
import Dialog from '@ui/Dialog';
import Button from '@ui/Button';
import { last } from 'lodash-es';
import Typography from '@ui/Typography';
import { ScrollArea } from '@ui/ScrollArea';
import getSymbolFromCurrency from 'currency-symbol-map';
import DonationTrackerVerticalStepper from './DonationTrackerVerticalStepper';
import useDonationTrackerPopUpStore from '@/components/store/donationTrackerPopUpSlice';
import {
  fetchDonationTracker,
  fetchGiftOfGivingTracker,
} from '@/actions/server.actions';

function DonationTrackerPopUp(props) {
  const {
    open: isOpen,
    donationId,
    setClose,
    type,
    company,
    nonProfit,
    amount,
    currency,
  } = useDonationTrackerPopUpStore((state) => state);

  const [loading, setLoading] = useState(false);
  const [donation, setDonation] = useState();

  const dialogTitle = 'Track your donation';

  const handleClose = () => {
    setClose();
  };

  const fetchDonation = async (id) => {
    setLoading(true);
    let api;
    if (type === 'donations') {
      api = fetchDonationTracker(id);
    } else if (type === 'giftOfGiving') {
      api = fetchGiftOfGivingTracker(id);
    }
    const donationData = await api;
    console.log('donationData', donationData);
    if (donationData) {
      setDonation(donationData);
    } else {
      setDonation(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isOpen && donationId) {
      fetchDonation(donationId);
    }
  }, [isOpen, donationId, nonProfit]);

  if (!nonProfit) return null;

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      loading={loading}
      maxWidth="lg"
      titleClass="!text-center"
      contentClass="!pt-2 !px-4 !pb-4"
      title={dialogTitle}>
      <ScrollArea className="w-full flex-1">
        <Typography variant="body2" className="mb-4 text-center font-medium">
          We are proud to provide you with transparency and visibility.
        </Typography>
        <div className="ml-8 flex flex-col justify-center gap-6">
          <div>
            <Typography variant="h2" className="font-medium">
              {getSymbolFromCurrency(currency)}
              {amount || 0} donated to{' '}
              <span className="">
                {nonProfit.name}, {nonProfit.country}
              </span>
            </Typography>
          </div>
          {donation?.tracker && (
            <div className="w-full max-w-lg gap-6 self-center">
              <DonationTrackerVerticalStepper
                company={company}
                nonProfit={nonProfit}
                tracker={donation?.tracker}
              />
            </div>
          )}
          {donation?.companyMatch?.tracker && (
            <div className="mt-4">
              <Typography variant="h2" className="font-medium">
                {getSymbolFromCurrency(currency)}
                {donation?.companyMatch?.donationAmount} Company Match
              </Typography>
            </div>
          )}

          {donation?.companyMatch?.tracker && (
            <div className="w-full max-w-lg self-center">
              <DonationTrackerVerticalStepper
                company={company}
                nonProfit={nonProfit}
                tracker={donation?.companyMatch?.tracker}
              />
            </div>
          )}
        </div>
        <div className="flex justify-end">
          <Button onClick={handleClose}>Close</Button>
        </div>
      </ScrollArea>
    </Dialog>
  );
}

export default DonationTrackerPopUp;
